export const solutions = {
  is: {
    title: "Lausnir",
    description: "Sérsniðnar lausnir fyrir þitt fyrirtæki",
    ai: {
      title: "Gervigreind",
      description: "AI lausnir fyrir fyrirtæki",
      features: {
        chatbot: "Spjallmenni",
        automation: "Sjálfvirkni",
        analysis: "Greining"
      }
    },
    booking: {
      title: "Bókunarkerfi",
      description: "Sjálfvirk bókunarkerfi",
      features: {
        online: "Netbókanir",
        payment: "Greiðslugáttir",
        reminders: "Áminningar"
      }
    },
    subscription: {
      title: "Áskriftarkerfi",
      description: "Recurring revenue lausnir",
      features: {
        management: "Áskriftarstýring",
        payment: "Greiðslur",
        users: "Notendastýring"
      }
    },
    ecommerce: {
      title: "Netverslun",
      description: "WooCommerce / Shopify",
      features: {
        products: "Vörustjórnun",
        payment: "Greiðslugáttir",
        shipping: "Sendingar"
      }
    },
    pos: {
      title: "Kassakerfi",
      description: "POS lausnir",
      features: {
        sales: "Sölukerfi",
        inventory: "Birgðastýring",
        reports: "Skýrslur"
      }
    },
    wordpress: {
      title: "WordPress",
      description: "WordPress lausnir",
      features: {
        cms: "Efnisstjórnun",
        plugins: "Viðbætur",
        themes: "Þemu"
      }
    },
    wordpressExpress: {
      title: "WordPress Express",
      description: "Hraðvirk WordPress lausn",
      features: {
        price: "Frá 99.950 án/vsk.",
        pages: "10-15 síður",
        theme: "Tilbúið þema"
      }
    },
    hosting: {
      title: "Vefhýsing",
      description: "Örugg hýsing",
      features: {
        uptime: "99.9% uppitími",
        backup: "Öryggisafritun",
        support: "24/7 þjónusta"
      }
    },
    email: {
      title: "Tölvupóstur",
      description: "Tölvupóstþjónusta",
      features: {
        professional: "Fagleg netföng",
        spam: "Ruslpóstvörn",
        storage: "Stór pósthólf"
      }
    },
    management: {
      title: "Vefumsjón",
      description: "Viðhald og öryggi",
      features: {
        updates: "Uppfærslur",
        security: "Öryggiseftirlit",
        backup: "Öryggisafritun"
      }
    },
    chat: {
      title: "Netspjall",
      description: "AI spjallmenni",
      features: {
        ai: "Gervigreind",
        support: "24/7 þjónusta",
        integration: "Samþætting"
      }
    },
    api: {
      title: "API Tengingar",
      description: "Samþætting við önnur kerfi",
      features: {
        custom: "Sérsniðin API",
        integration: "Kerfisamþætting",
        security: "Örugg samskipti"
      }
    }
  },
  en: {
    title: "Solutions",
    description: "Custom solutions for your business",
    ai: {
      title: "AI Solutions",
      description: "AI solutions for businesses",
      features: {
        chatbot: "Chatbots",
        automation: "Automation",
        analysis: "Analysis"
      }
    },
    booking: {
      title: "Booking System",
      description: "Automated booking systems",
      features: {
        online: "Online bookings",
        payment: "Payment gateways",
        reminders: "Reminders"
      }
    },
    subscription: {
      title: "Subscription System",
      description: "Recurring revenue solutions",
      features: {
        management: "Subscription management",
        payment: "Payments",
        users: "User management"
      }
    },
    ecommerce: {
      title: "E-commerce",
      description: "WooCommerce / Shopify",
      features: {
        products: "Product management",
        payment: "Payment gateways",
        shipping: "Shipping"
      }
    },
    pos: {
      title: "POS System",
      description: "POS solutions",
      features: {
        sales: "Sales system",
        inventory: "Inventory management",
        reports: "Reports"
      }
    },
    wordpress: {
      title: "WordPress",
      description: "WordPress solutions",
      features: {
        cms: "Content management",
        plugins: "Plugins",
        themes: "Themes"
      }
    },
    wordpressExpress: {
      title: "WordPress Express",
      description: "Fast WordPress solution",
      features: {
        price: "From $799 excl. VAT",
        pages: "10-15 pages",
        theme: "Ready-made theme"
      }
    },
    hosting: {
      title: "Hosting",
      description: "Secure hosting",
      features: {
        uptime: "99.9% uptime",
        backup: "Backup",
        support: "24/7 support"
      }
    },
    email: {
      title: "Email",
      description: "Email service",
      features: {
        professional: "Professional email",
        spam: "Spam protection",
        storage: "Large mailboxes"
      }
    },
    management: {
      title: "Management",
      description: "Maintenance and security",
      features: {
        updates: "Updates",
        security: "Security monitoring",
        backup: "Backup"
      }
    },
    chat: {
      title: "Live Chat",
      description: "AI chatbot",
      features: {
        ai: "Artificial Intelligence",
        support: "24/7 service",
        integration: "Integration"
      }
    },
    api: {
      title: "API Connections",
      description: "Integration with other systems",
      features: {
        custom: "Custom APIs",
        integration: "System integration",
        security: "Secure communication"
      }
    }
  },
  es: {
    title: "Soluciones",
    description: "Soluciones personalizadas para su empresa",
    ai: {
      title: "Soluciones de IA",
      description: "Soluciones de IA para empresas",
      features: {
        chatbot: "Chatbots",
        automation: "Automatización",
        analysis: "Análisis"
      }
    },
    booking: {
      title: "Sistema de Reservas",
      description: "Sistemas de reservas automatizados",
      features: {
        online: "Reservas en línea",
        payment: "Pasarelas de pago",
        reminders: "Recordatorios"
      }
    },
    subscription: {
      title: "Sistema de Suscripción",
      description: "Soluciones de ingresos recurrentes",
      features: {
        management: "Gestión de suscripciones",
        payment: "Pagos",
        users: "Gestión de usuarios"
      }
    },
    ecommerce: {
      title: "Comercio Electrónico",
      description: "WooCommerce / Shopify",
      features: {
        products: "Gestión de productos",
        payment: "Pasarelas de pago",
        shipping: "Envíos"
      }
    },
    pos: {
      title: "Sistema POS",
      description: "Soluciones POS",
      features: {
        sales: "Sistema de ventas",
        inventory: "Gestión de inventario",
        reports: "Informes"
      }
    },
    wordpress: {
      title: "WordPress",
      description: "Soluciones WordPress",
      features: {
        cms: "Gestión de contenido",
        plugins: "Plugins",
        themes: "Temas"
      }
    },
    wordpressExpress: {
      title: "WordPress Express",
      description: "Solución WordPress rápida",
      features: {
        price: "Desde 799€ sin IVA",
        pages: "10-15 páginas",
        theme: "Tema prediseñado"
      }
    },
    hosting: {
      title: "Hosting",
      description: "Hosting seguro",
      features: {
        uptime: "99.9% de tiempo activo",
        backup: "Copia de seguridad",
        support: "Soporte 24/7"
      }
    },
    email: {
      title: "Correo Electrónico",
      description: "Servicio de correo electrónico",
      features: {
        professional: "Correo profesional",
        spam: "Protección antispam",
        storage: "Buzones grandes"
      }
    },
    management: {
      title: "Gestión Web",
      description: "Mantenimiento y seguridad",
      features: {
        updates: "Actualizaciones",
        security: "Monitoreo de seguridad",
        backup: "Copia de seguridad"
      }
    },
    chat: {
      title: "Chat en Vivo",
      description: "Chatbot con IA",
      features: {
        ai: "Inteligencia Artificial",
        support: "Servicio 24/7",
        integration: "Integración"
      }
    },
    api: {
      title: "Conexiones API",
      description: "Integración con otros sistemas",
      features: {
        custom: "APIs personalizadas",
        integration: "Integración de sistemas",
        security: "Comunicación segura"
      }
    }
  },
  da: {
    title: "Løsninger",
    description: "Skræddersyede løsninger til din virksomhed",
    ai: {
      title: "AI-løsninger",
      description: "AI-løsninger til virksomheder",
      features: {
        chatbot: "Chatbots",
        automation: "Automatisering",
        analysis: "Analyse"
      }
    },
    booking: {
      title: "Bookingsystem",
      description: "Automatiserede bookingsystemer",
      features: {
        online: "Online bookinger",
        payment: "Betalingsgateways",
        reminders: "Påmindelser"
      }
    },
    subscription: {
      title: "Abonnementssystem",
      description: "Løsninger til tilbagevendende omsætning",
      features: {
        management: "Abonnementsstyring",
        payment: "Betalinger",
        users: "Brugerstyring"
      }
    },
    ecommerce: {
      title: "E-handel",
      description: "WooCommerce / Shopify",
      features: {
        products: "Produktstyring",
        payment: "Betalingsgateways",
        shipping: "Forsendelse"
      }
    },
    pos: {
      title: "POS-system",
      description: "POS-løsninger",
      features: {
        sales: "Salgssystem",
        inventory: "Lagerstyring",
        reports: "Rapporter"
      }
    },
    wordpress: {
      title: "WordPress",
      description: "WordPress-løsninger",
      features: {
        cms: "Indholdsstyring",
        plugins: "Plugins",
        themes: "Temaer"
      }
    },
    wordpressExpress: {
      title: "WordPress Express",
      description: "Hurtig WordPress-løsning",
      features: {
        price: "Fra 5.995 kr. ekskl. moms",
        pages: "10-15 sider",
        theme: "Færdigt tema"
      }
    },
    hosting: {
      title: "Hosting",
      description: "Sikker hosting",
      features: {
        uptime: "99.9% oppetid",
        backup: "Backup",
        support: "24/7 support"
      }
    },
    email: {
      title: "Email",
      description: "Email-service",
      features: {
        professional: "Professionel email",
        spam: "Spambeskyttelse",
        storage: "Store postkasser"
      }
    },
    management: {
      title: "Webadministration",
      description: "Vedligeholdelse og sikkerhed",
      features: {
        updates: "Opdateringer",
        security: "Sikkerhedsovervågning",
        backup: "Backup"
      }
    },
    chat: {
      title: "Live Chat",
      description: "AI-chatbot",
      features: {
        ai: "Kunstig Intelligens",
        support: "24/7 service",
        integration: "Integration"
      }
    },
    api: {
      title: "API Forbindelser",
      description: "Integration med andre systemer",
      features: {
        custom: "Tilpassede API'er",
        integration: "Systemintegration",
        security: "Sikker kommunikation"
      }
    }
  }
};